export default "<div [ngStyle]=\"{'background': selectedBackground}\" class=\"landing-page\">\n</div>\n"